import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { rootReducer } from './reducer';
import { rootSaga } from './saga';
export var configureStore = function () {
    var sagaMiddleware = createSagaMiddleware();
    var middlewares = [sagaMiddleware];
    var enhancers = [
        applyMiddleware.apply(void 0, middlewares),
    ];
    var store = createStore(rootReducer, compose.apply(void 0, enhancers));
    sagaMiddleware.run(rootSaga);
    return store;
};
